export enum InjectedTypes {
  Any = "Any",
  Ad = "Ad",
  Native = "Native",
  House = "House",
  Recirc = "Recirc",
  Books = "Books",
}

export enum ArticleElementTypes {
  Begin = "Begin",
  Heading = "Heading",
  Figure = "Figure",
  Quote = "Quote",
  End = "End",
  List = "List",
  HorizRule = "HorizRule",
  BracketedLink = "BracketedLink",
  LegacyHtml = "LegacyHtml",
  AdPlaceholder = "AdPlaceholder",
  RecircPlaceholder = "RecircPlaceholder",
  Dropcap = "Dropcap",
  Salutations = "Salutations",
}

export type Rule = {
  item: InjectedTypes;
  from: InjectedTypes | ArticleElementTypes;
  index?: number;
  indexNotEqual?: number;
  after?: string;
  before?: string;
};

export type RuleInPixels = {
  item: InjectedTypes;
  from: InjectedTypes | ArticleElementTypes;
  index?: number;
  indexNotEqual?: number;
  after?: number;
  before?: number;
};

export interface ElementPosition {
  /** the top y position */
  top: number;
  /** the bottom y position */
  bottom: number;
  /** the top y position including the top margin */
  topMargin: number;
  /** the bottom y position including the bottom margin */
  bottomMargin: number;
}

export interface OverlapBlock {
  /** the start index of the block of overlapping elements */
  start: number;
  /** the end index of the block of overlapping elements */
  end: number;
}

export interface InjectedComponent {
  type: InjectedTypes;
  afterIndex: number;
}
